module.exports = __webpack_public_path__ + "static/media/  (84).177517cb.jpg";